import { memo } from 'react';
import { PLACEHOLDER_CLASS } from '../../utils/constants';

interface LoadingRowsProps {
  columnsCount: number;
  rowsCount: number;
  hasActions: boolean;
}

const LoadingRows = memo(
  ({ columnsCount, rowsCount, hasActions }: LoadingRowsProps) => {
    const totalColumns = hasActions ? columnsCount + 1 : columnsCount;

    return (
      <>
        {Array.from({ length: rowsCount }).map((_, rowIndex) => (
          <tr key={`loading-row-${rowIndex}`}>
            {Array.from({ length: totalColumns }).map((_, colIndex) => (
              <td
                key={`loading-cell-${rowIndex}-${colIndex}`}
                className="text-center"
              >
                <div
                  className={PLACEHOLDER_CLASS}
                  style={{ height: '1.5rem' }}
                />
              </td>
            ))}
          </tr>
        ))}
      </>
    );
  },
);

LoadingRows.displayName = 'LoadingRows';

export default LoadingRows;
